// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubformSpecial_wrapper__AcggW","main-description":"SubformSpecial_main-description__0xDkD","photo-description":"SubformSpecial_photo-description__MW9PJ"};